var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_131_2993",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_131_2993",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABmUlEQVR4Ae2ZAUdDURiG27Uhym2Xqv8w6A/0Yy4syP5EiIEIgBkJCXATgP5DFhAGMOreIWTj9uLic2ydnWzOvd95Hx4duyFv7/dtx/YIIf+hrKnORFAVDMBDAC3hs7Bl6v7cLhvAABhAnQJgAEtx7kBJJ4QApuLcg5JeCAG8i/MAnsP96ucA1o423CaP8AIewWN4HdoOmMMhLOB67Dti2eR3gTd4BTP4AX/gDL7Azw13xLQ5t0E3UphVjowdMRLP+rv5W/wHcAIfYPaH9zCGm9Ko6/AM3sBvuIoCDuFc5QgIYngJ7+ATvIV9+Z/XOgLuKBsBXoYYAAPQfRco2QAGEPYItNgABsAA+FGYX4/bnUCTSUhfj3/ZX9OxAxZbCGABVZCKqo6hyVg8TzW+C3QdGtDVGMChQwAHGgM4FeccmsjXzjQGkDg0ING+A1Y2QO0OYAMYAEcggrG4RxTQpBCf52NtF7UElpU5XEcufi9R0ABb/f2PQeRzAfpchGwAG8AAOAJsAAPgCLABbQ8NeIUWFDfAgYQB7BpCyC/4ScjsPrdwJQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService8);
export default __webpack_public_path__ + "static/media/service8.bafd4d39dbeeed26dd6c2e5f0c30090f.svg";
export { ForwardRef as ReactComponent };